module.exports = __webpack_public_path__ + "img/braille-nyomtatas-thumb.5727aeb0.jpg";